// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{margin: 0}\n.bt{\n    background-color: #ffdddd;\n    height: 100%;\n}", ""]);
// Exports
module.exports = exports;
